import React, { Component } from 'react';
import styled from 'styled-components';
import ProductCard from './ProductCard';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Processing from './Processing';
import media from './MediaQueries';
import { translate } from 'react-polyglot';

const StyledProductWrapper = styled.div`
  width: 100%;
  height: 120px;
  ul,
  li {
    list-style: none;
  }
  ul {
    width: auto;
    display: flex;
    position: absolute;
    left: 0;
    top: -80px;
    ${media.phone`
      top: auto;
    `}
  }
`;

const StyledHintContainer = styled.div`
  width: 100%;
  text-align: center;
  font-size: 18px;
  color: white;
  margin: auto;
`;

const StyledAddAllButton = styled.div`
  position: relative;
  top: -130px;
  left: 0px;
  cursor: pointer;
  background: ${props => (props.clicked ? '#64a05d' : '#bbb')};
  padding: 10px;
  border-radius: 4px;
  color: white;
  font-style: italic;
  font-size: 14px;
  font-weight: 700;
  width: 170px;
  text-align: center;
  ${media.phone`
    top: -50px;
  `}
`;

class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      prods: [],
      products: props.products,
      pricegroup: props.pricegroup,
      addAllClicked: false,
    };
  }

  componentDidMount() {
    this.loadProds();
  }

  componentWillReceiveProps(newProps) {
    const { products, pricegroup } = this.state;
    if (JSON.stringify(products) !== JSON.stringify(newProps.products)) {
      this.setState(
        {
          loading: true,
          products: newProps.products,
        },
        () => this.loadProds(),
      );
    }
    if (pricegroup !== newProps.pricegroup) {
      this.setState(
        {
          loading: true,
          pricegroup: newProps.pricegroup,
        },
        () => this.loadProds(),
      );
    }
  }

  handleAddAllToCart = () => {
    const { configOptions } = this.props;
    if (configOptions.results.addAllToCartButton.callback) {
      eval(configOptions.results.addAllToCartButton.callback);
    }
    this.setState({
      addAllClicked: true,
    });
  };

  mapRegimen = ({ regimens, filters = {} }) => {
    const [, regimen] = Object.entries(regimens).find(([key, value]) => filters[key] || filters[`${key}_ui`]) || [];
    if (regimen && typeof regimen === 'object' && !Array.isArray(regimen))
      return this.mapRegimen({ regimens: regimen, filters });
    return regimen;
  };

  loadProds = () => {
    const { configOptions, loadingProducts, filters, triggerCallback } = this.props;
    const { pricegroup, products } = this.state;
    let prods = [];
    if (products) {
      if (configOptions.results.priceGroups) {
        if (pricegroup && products.hasOwnProperty(pricegroup)) {
          prods = Object.keys(products[pricegroup]).map(cat => {
            return products[pricegroup][cat];
          });
        } else if (!pricegroup) {
          Object.keys(products).map(pricegroup => {
            Object.keys(products[pricegroup]).map(cat => {
              prods.push(products[pricegroup][cat]);
              return true;
            });
            return true;
          });
        }
      } else {
        prods = Object.keys(products).map(productKey => {
          return products[productKey];
        });
      }
    }

    const regimen = this.mapRegimen({ regimens: configOptions.categories.regimen, filters }) || [];
    prods.sort((a, b) => regimen.indexOf(a.category) - regimen.indexOf(b.category));
    this.setState({
      loading: loadingProducts,
      prods,
      addAllClicked: false,
    });
    if (prods && prods.length > 0) triggerCallback({ callback: 'displayProducts', payload: prods });
  };

  render = () => {
    const { prods, loading, addAllClicked } = this.state;
    const { configOptions, t } = this.props;
    const withProductsAndAddAllToCartButton =
      prods.length > 0 && configOptions.results.addAllToCartButton && configOptions.results.addAllToCartButton.show;
    return (
      <StyledProductWrapper className="revieveProductWrapper">
        {loading ? (
          <Processing key={2} label={t('loading_products')} />
        ) : (
          <ReactCSSTransitionGroup
            transitionName="footerSlide"
            transitionAppear={true}
            transitionEnter={true}
            transitionLeave={true}
            transitionAppearTimeout={900}
            transitionLeaveTimeout={900}
            transitionEnterTimeout={900}
          >
            {prods.length > 0 ? (
              <ul key={1}>
                {prods.map(product => {
                  return (
                    <ProductCard key={product.id} product={product} configOptions={configOptions} {...this.props} />
                  );
                })}
              </ul>
            ) : (
              <StyledHintContainer>{t('no_products')}</StyledHintContainer>
            )}
            {withProductsAndAddAllToCartButton && (
              <StyledAddAllButton clicked={addAllClicked} className="addAllToCart" onClick={this.handleAddAllToCart}>
                {configOptions.results.addAllToCartButton.text}
              </StyledAddAllButton>
            )}
          </ReactCSSTransitionGroup>
        )}
      </StyledProductWrapper>
    );
  };
}

export default translate()(Products);



// WEBPACK FOOTER //
// ./src/components/instore/Products.js